var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"title":"Unqualified"}},[_c('h6',[_vm._v("You are already employed!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }